export const BOOK_URL = "https://www.thevaliant.au/bottomless-afterparty/";
export const TICKETS_URL = "https://www.eventbrite.com.au/e/elegante-grand-opening-week-001-tickets-2003756155601?dsrp_sid=c7a234af-51cd-4aad-8170-b5a4e612a177&aff=ebdssbdestsearch";
export const IG_URL = "https://www.instagram.com/elegantemelbourne/";
export const EMAIL = "eleganteclubmelb@gmail.com";
export const ADDRESS = "Level 1/412 Little Collins St, Melbourne VIC 3000";
export const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;

export const M = {
  logo: "/media/logo.webp",
  flyer: "/media/flyer.jpg",
  team: "/media/team.webp",
  guestlist: "/media/guestlist.webp",
  video: "/media/hero.mp4",
  poster: "/media/hero-poster.jpg",
  toast: "/media/champagne.jpg",
  heel: "/media/toast.webp",
  champagne: "/media/heel.webp",
  girls: "/media/frame-18.jpg",
  table: "/media/frame-28.jpg",
  dance: "/media/frame-48.jpg",
  ceiling: "/media/frame-56.jpg",
};

export const EASE = [0.22, 1, 0.36, 1];

// Grand opening: Friday 13 November 2026, 9PM Melbourne time (wall-clock, pseudo-UTC).
export const OPENING = Date.UTC(2026, 10, 13, 21, 0, 0);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
